module.exports = __webpack_public_path__ + "img/TransporNet-Antes.637154a8.png";